import React, { useEffect, useState } from 'react';

import Image from './Image';

export default function Button({
    type = 1,
    title,
    onClick = () => { },
    opacity = true,
    disable = false,
    round,
    image,
    style,
    imgStyle
}) {

    return (
        <button style={style} type="button" className={`btn ${!opacity ? 'btn_clearly' : ''} btn${type} ${round ? 'btn_round' : ''} ${disable ? 'disable' : ""}`} onClick={onClick} disabled={disable}>
            {image ? (
                <Image src={image} style={imgStyle} />
            ) : (
                <></>
            )}
            {title}
        </button>
    )
}